<template>
  <div :class="sizeClass">
    <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 100 100" class="h-auto">
      <path d="M50 0C22.4 0 0 22.4 0 50h100C100 22.4 77.6 0 50 0z" :class="colorClasses[0]" />
      <path d="M50 100C22.4 100 0 77.6 0 50h100C100 77.6 77.6 100 50 100z" :class="colorClasses[1]" />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Swatch',
  props: {
    color: {
      type: String,
      required: true,
    },
    isSmall: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    colorClasses() {
      const classes = this.color.toLowerCase().split('_');
      if (classes.length < 2) {
        classes.push(classes[0]);
      }
      return classes.map((item) => `swatch-${item}`);
    },
    sizeClass() {
      return 'swatch-container' + (this.isSmall ? ' swatch-container--small' : '');
    },
  },
};
</script>
